<div
  *ngIf="tableData"
  #tableBody
  class="results-table table-container"
  [ngClass]="{
    'project-input': isProjectInput && !isResultsLoaded,
    'project-input-results': isProjectInput && isResultsLoaded
  }">
  <table mat-table [dataSource]="tableData">
    <ng-container *ngFor="let name of tableHeaders" >
      <ng-container [matColumnDef]="name" *ngIf="name === 'label' || name === 'name'" sticky>
        <th mat-header-cell
            *matHeaderCellDef
            class="table-header"
            [ngClass]="{'table-cell-separators': showTableSeparators, 'first-column-border': showFirstColumnSeparator}"
        >{{ name }}</th>
        <td mat-cell
            *matCellDef="let element"
            [ngClass]="{
            'total-row': isTotalRow(element[name]),
            'table-cell-separators': showTableSeparators,
            'first-column-border': showFirstColumnSeparator
            }">
          <ng-container *ngIf="numberCheck(element[name])">
              {{ formatDecimalPlaces(element[name]) }}
          </ng-container>
          <ng-container *ngIf="!numberCheck(element[name])">
            <div [anessaTranslation]='element[name]'></div>
          </ng-container>
        </td>
      </ng-container>
      <ng-container [matColumnDef]="name" *ngIf="name !== 'label' && name !== 'name'" >
        <th mat-header-cell
            *matHeaderCellDef
            class="table-header"
            [ngClass]="{'table-cell-separators': showTableSeparators, 'first-column-border': showFirstColumnSeparator}"
        >{{ name }}</th>
        <td mat-cell
            *matCellDef="let element; let i = index;"
            (click)="edit(i, name)"
            [ngStyle]="{'color': (numberCheck(element[name]) && element[name]) < 0 ? '#ef4136' : ''}"
            [ngClass]="{'table-cell-separators': showTableSeparators, 'first-column-border': showFirstColumnSeparator}"
        >
          <ng-container *ngIf="numberCheck(element[name])">
              <span *ngIf="!allowEdit(i, name) else editItemCell">
                {{ formatDecimalPlaces(element[name]) }}
              </span>
              <ng-template #editItemCell>
                <mat-form-field floatLabel="never">
                  <input
                    matInput
                    type="number"
                    [(ngModel)]="element[name]"
                    (ngModelChange)="formDirty = true"
                    (focusout)="edit(null, null);">
                </mat-form-field>
              </ng-template>
          </ng-container>
          <ng-container *ngIf="!numberCheck(element[name])">
            <div [anessaTranslation]='element[name]'></div>
          </ng-container>
        </td>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="numberCheck(cell)">
        {{ formatDecimalPlaces(cell) }}
      </ng-container>
      <ng-container *ngIf="!numberCheck(cell)">
        {{cell}}
      </ng-container>

    <tr mat-header-row *matHeaderRowDef="tableHeaders; sticky: true" ></tr>
    <tr mat-row *matRowDef="let row; columns: tableHeaders;"></tr>
  </table>
</div>

<div class="results-container media-button-container"
     *ngIf="showTable && !isProjectInput">
  <button mat-button class="btn-green save-media-button"
          (click)="openDialog(false)">{{'RESULTS.GENERAL.SAVE_CSV_FILE_TO_PC' | anessaTranslation: trigger}}
  </button>
</div>
<div *ngIf="!isProjectInput" class="bottom-spacing"></div>
